import styled from "styled-components";

const SlugViagemDetails = styled.div`
  width: 100%;

  margin: 100px 0px 40px 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  .content {
    width: 100%;
    max-width: 1200px;
  }

  .content-page {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 20px;
  }

  .breadcrumb {
    display: flex;
    align-items: flex-start;

    gap: 15px;
    color: #767676;

    margin-bottom: 40px;
    a {
      text-decoration: none;
      color: #767676;

      &:hover {
        color: #222;
      }
    }

    .atual {
      font-weight: 500;
      color: #222;
    }

    @media (max-width: 850px) {
      font-size: 0.85rem;
    }

    @media (max-width: 450px) {
      font-size: 0.75rem;
    }
  }

  .title {
    font-size: 2rem;
    font-weight: 500;
    margin-top: 50px;

    @media (max-width: 850px) {
      font-size: 1.5rem;
    }
  }

  .header {
    width: 100%;
    display: flex;
    gap: 20px;

    @media (max-width: 1250px) {
      justify-content: space-between;
    }

    @media (max-width: 850px) {
      flex-direction: column;
      gap: 20px;
    }
  }

  .carousel {
    width: 70%;

    @media (max-width: 1250px) {
      width: 60%;
    }

    @media (max-width: 1000px) {
      width: 50%;
    }

    @media (max-width: 850px) {
      width: 100%;
    }

    img {
      height: 400px;
      width: 100%;
      object-fit: cover;
    }

    /* @media (max-width: 400px) {
            background-color: rgba(0, 0, 0, 0.1);
            img{
                object-fit: contain;
            }
        } */
  }

  .card-info {
    width: 30%;
    background-color: #fff;

    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

    padding: 20px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: 1250px) {
      width: 356px;
    }

    @media (max-width: 850px) {
      width: 100%;
    }

    .location {
      width: 100%;

      display: flex;
      align-items: center;
      gap: 10px;

      font-size: 1.2rem;
    }
  }

  .desc {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 20px;

    .title-desc {
      font-size: 1.1rem;

      font-weight: 500;
    }
  }

  .line {
    width: 100%;
    height: 1px;

    background-color: rgba(0, 0, 0, 0.1);
  }

  .preco {
    width: 100%;

    .info {
      width: 70px;
    }

    .currency {
      font-size: 2rem;
      font-weight: 500;
    }
  }

  .info-viagem {
    display: flex;
    gap: 10px;

    @media (max-width: 850px) {
      gap: 30px;
    }
  }

  .partida,
  .retorno {
    width: 100%;

    display: flex;
    align-items: center;
    gap: 10px;

    font-size: 0.95rem;

    @media (max-width: 850px) {
      width: auto;
    }

    @media (max-width: 400px) {
      font-size: 0.85rem;
    }

    .icon {
      font-size: 1.2rem;
    }
  }

  .button {
    padding: 15px 20px;

    border: none;
    outline: none;
    background-color: #df8925;

    color: white;

    border-radius: 6px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    text-decoration: none;

    &:hover {
      background-color: #d4a35e;
    }
  }
`;

export default SlugViagemDetails;
